import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppService } from '../../../../app.service';
import { PreferencesService } from '../../preferences.service';
import { NotificationsService } from 'angular2-notifications';
import { Subscription } from 'rxjs/Subscription';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { UserService } from '../../../../../app/shared/services/user.service';
import { AlertVM } from '../../../../../app/entities/alerts/alerts';
import { MatDialog } from '@angular/material/dialog';
import { AlertPercentageSettingsPopupComponent } from '../Popup/alert-percentage-settings-popup/alert-percentage-settings-popup.component';

@Component({
    selector: 'app-alerts-view',
    templateUrl: './alerts-view.component.html',
    styleUrls: ['./alerts-view.component.scss']
})
export class AlertsViewComponent implements OnInit, OnDestroy {
    loadingPreferences: boolean = true;
    private subscriptions: Subscription[] = [];
    InspectionsDueEmails: boolean = false;
    DailyInspectionsDueEmails: boolean = false;
    EnablePIPEmails: boolean = false
    EnableDFIEmails: boolean = false;
    EnableNSWEmails: boolean = false
    EnableDashboardAlerts: boolean = false
    EnableQLDEmails: boolean = false
    EnableWAEmails: boolean = false
    isSupervisor: boolean = false;
    ShowAlertFiled: boolean = false;
    constructor(private readonly _app: AppService, private _user: UserService,
        private readonly _pref: PreferencesService,
        private readonly _notify: NotificationsService, private dialog: MatDialog) { }

    ngOnInit() {
        this._app.setPageTitle('Preferences | Alerts');
        this.LoadJobRoles();
        this.loadAllData();
        this.GetAlertsAsync();
        this.LoadShowAlertTab();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => { if (!s.closed) s.unsubscribe() });
    }


    LoadJobRoles() {
        this._user.getUserJobRoles().subscribe(roles => {
            roles.forEach(r => {
                switch (r.Name) {
                    case 'Supervisor':
                        this.isSupervisor = true;
                        break;
                }
            });

        })
    }

    LoadShowAlertTab() {
        this._user.HasShowAlert().subscribe(roles => {
            if (roles) {
                this.ShowAlertFiled = roles;
            }

        })
    }

    loadAllData() {
        let inspectionsDueEmail = this._pref.getInspectionsDueEmails();
        this._pref.getDailyInspectionsDueEmails().subscribe(res => {
            if (res == "True") {
                this.DailyInspectionsDueEmails = true;
            } else {
                this.DailyInspectionsDueEmails = false;
            }
        });

        this.subscriptions.push(forkJoin([inspectionsDueEmail]).subscribe(results => {
            if (results[0] == "True") {
                this.InspectionsDueEmails = true;
            } else {
                this.InspectionsDueEmails = false;
            }

            this.loadingPreferences = false;
        }, error => {
            console.error(error);
            this._notify.error('Error', 'Unable to load your preferences. Please contact TrackTreads support. ');
        }));

        this._pref.GetDFIEmailsEnableStatus().subscribe(res => {
            if (res == "True") {
                this.EnableDFIEmails = true;
            } else {
                this.EnableDFIEmails = false;
            }
        });

        this._pref.GetDashBoardAlertEnableStatus().subscribe(res => {
            if (res == "True") {
                this.EnableDashboardAlerts = true;
            } else {
                this.EnableDashboardAlerts = false;
            }
        });


        this._pref.GetNSWEmailsEnableStatus().subscribe(res => {
            if (res == "True") {
                this.EnableNSWEmails = true;
            } else {
                this.EnableNSWEmails = false;
            }
        });

        this._pref.GetWAEmailsEnableStatus().subscribe(res => {
            if (res == "True") {
                this.EnableWAEmails = true;
            } else {
                this.EnableWAEmails = false;
            }
        });
    }

    updateInspectionsDueEmail(e) {
        var status = !this.InspectionsDueEmails;

        this._pref.updateInspectionsDueEmails(status).subscribe(r => {
            if (r.m_Item1) {
                this._notify.success('Saved', r.m_Item2);
            } else {
                this._notify.error('Error', 'Unable to update Inspections Due Emails. Please contact TrackTreads support. ');
                console.error(r.m_Item2);
            }
        }, error => {
            console.error(error);
            this._notify.error('Error', 'Unable to update Inspections Due Emails. Please contact TrackTreads support. ');
        });
    }

    updateDashBoardAlertStatus(e) {
        var status = !this.EnableDashboardAlerts;

        this._pref.UpdateDashboardAlerts(status).subscribe(r => {
            if (r.m_Item1) {
                this._notify.success('Saved', r.m_Item2);
            } else {
                this._notify.error('Error', 'Unable to update user dashboard status. Please contact TrackTreads support. ');
                console.error(r.m_Item2);
            }
        }, error => {
            console.error(error);
            this._notify.error('Error', 'Unable to update user dashboard status. Please contact TrackTreads support. ');
        });
    }

    updateDailyInspectionsDueEmail(e) {
        var status = !this.DailyInspectionsDueEmails;

        this._pref.updateDailyInspectionsDueEmails(status).subscribe(r => {
            if (r.m_Item1) {
                this._notify.success('Saved', r.m_Item2);
            } else {
                this._notify.error('Error', 'Unable to update Inspections Due Emails. Please contact TrackTreads support. ');
                console.error(r.m_Item2);
            }
        }, error => {
            console.error(error);
            this._notify.error('Error', 'Unable to update Inspections Due Emails. Please contact TrackTreads support. ');
        });
    }


    UpdateEnablePIPEmails(e) {
        var status = !this.EnablePIPEmails;

        this._pref.UpdateEnablePIPEmails(status).subscribe(r => {
            if (r.m_Item1) {
                this._notify.success('Saved', r.m_Item2);
            } else {
                this._notify.error('Error', 'Unable to update Enable PIP Emails. Please contact TrackTreads support. ');
                console.error(r.m_Item2);
            }
        }, error => {
            console.error(error);
            this._notify.error('Error', 'Unable to update Enable PIP Emails. Please contact TrackTreads support. ');
        });
    }

    UpdateEnableDFIEmails(e) {
        var status = !this.EnableDFIEmails;

        this._pref.UpdateEnableDFIEmails(status).subscribe(r => {
            if (r.m_Item1) {
                this._notify.success('Saved', r.m_Item2);
            } else {
                this._notify.error('Error', 'Unable to update Enable DFI Emails. Please contact TrackTreads support. ');
                console.error(r.m_Item2);
            }
        }, error => {
            console.error(error);
            this._notify.error('Error', 'Unable to update Enable DFI Emails. Please contact TrackTreads support. ');
        });
    }

    UpdateEnableQLDEmails(e) {
        var status = !this.EnableQLDEmails;

        this._pref.UpdateEnableQLDEmails(status).subscribe(r => {
            if (r.m_Item1) {
                this._notify.success('Saved', r.m_Item2);
            } else {
                this._notify.error('Error', 'Unable to update Enable QLD Emails. Please contact TrackTreads support. ');
                console.error(r.m_Item2);
            }
        }, error => {
            console.error(error);
            this._notify.error('Error', 'Unable to update Enable OLD Emails. Please contact TrackTreads support. ');
        });
    }

    UpdateEnableNSWEmails(e) {
        var status = !this.EnableNSWEmails;

        this._pref.UpdateEnableNSWEmails(status).subscribe(r => {
            if (r.m_Item1) {
                this._notify.success('Saved', r.m_Item2);
            } else {
                this._notify.error('Error', 'Unable to update Enable NSW Emails. Please contact TrackTreads support. ');
                console.error(r.m_Item2);
            }
        }, error => {
            console.error(error);
            this._notify.error('Error', 'Unable to update Enable NSW Emails. Please contact TrackTreads support. ');
        });
    }

    UpdateEnableWAEmails(e) {
        var status = !this.EnableWAEmails;

        this._pref.UpdateEnableWAEmails(status).subscribe(r => {
            if (r.m_Item1) {
                this._notify.success('Saved', r.m_Item2);
            } else {
                this._notify.error('Error', 'Unable to update Enable WA Emails. Please contact TrackTreads support. ');
                console.error(r.m_Item2);
            }
        }, error => {
            console.error(error);
            this._notify.error('Error', 'Unable to update Enable WA Emails. Please contact TrackTreads support. ');
        });
    }

    //#region Alerts
    AlertVM: AlertVM;
    GetAlertsAsync() {
        this._pref.GetAlertsAsync(1).subscribe(res => {
            this.AlertVM = res;
            console.log(this.AlertVM);
        }, error => {
            console.error(error);
            this._notify.error('Error', 'Unable to load alerts. Please contact TrackTreads support. ');
        });
    }

    onToggleChange(alert: any) {
        alert.isEnabled = !alert.IsEnabled;
        this._pref.updateAlertStatus(alert.AlertId, alert.IsEnabled)
            .subscribe({
                next: () => {
                    alert.isEnabled = !alert.isEnabled;
                    this._notify.success('Saved', 'Alert status updated.');
                },
                error: (err) => {
                    console.error(err);
                    this._notify.error('Error', 'Unable to update alert.');
                }
            });
    }

    onEmailToggle(alert: any) {

        if (!alert.IsEmailEnabled) return; // extra safety
        alert.IsEmailEnabled = !alert.IsEmailEnabled;
        this._pref.updateAlertStatus(alert.AlertId, alert.IsEnabled)
            .subscribe({
                next: () => {
                    alert.IsEmailEnabled = !alert.IsEmailEnabled;
                    this._notify.success('Saved', 'Alert  updated successfully.');
                },
                error: (err) => {
                    console.error(err);
                    this._notify.error('Error', 'Unable to update alert.');
                }
            });
    }
    //#endregion

    openSettings(alert: any) {

        const viewCommentModalRef = this.dialog.open(AlertPercentageSettingsPopupComponent, {
            width: '300px',
            data: {
                alertId: alert.AlertId,
                wornPercentage: alert.WornAlertValue
            }
        });
        viewCommentModalRef.afterClosed().subscribe(reloadComment => {
            if (reloadComment) {
                this.GetAlertsAsync()

            }
        });
    }
}
